// Pure gate for the drawer's Download Report button. A Diagnosis report is the
// paired result of both papers, so a student who has attempted only one of the
// two must not get a PDF. Kept framework-free so it runs under plain node.

const SINGLE_DIAGNOSIS_ATTEMPT_MESSAGE = 'Only 1 diagnosis attempted'

// The roster sets assessmentAssignedId1/2 only for attempted papers.
const countDiagnosisAttempts = (student) =>
  [student?.assessmentAssignedId1, student?.assessmentAssignedId2].filter(Boolean).length

const isSingleDiagnosisAttempt = (student, isDiagnosis) =>
  Boolean(isDiagnosis) && countDiagnosisAttempts(student) === 1

module.exports = { SINGLE_DIAGNOSIS_ATTEMPT_MESSAGE, countDiagnosisAttempts, isSingleDiagnosisAttempt }
